// types
import { FeatureFlag } from '../@types';

export function isFeatureEnabled(feature: FeatureFlag): boolean {
	return process.env[`REACT_APP_${feature}`] === 'true';
}

export const featureFlags: Record<FeatureFlag, boolean> = {
	CONTRACT_WORKFLOW: isFeatureEnabled('CONTRACT_WORKFLOW'),
};
